import {Collapse} from 'antd';
import cn from 'classnames';
import React, {FC, ReactNode} from 'react';

import {ReactComponent as AccordionIcon} from 'shared/assets/accordion-icon.svg';

import s from './collapsible-header.module.less';

interface ICollapsibleHeaderProps {
    children?: ReactNode;
    header?: ReactNode;
}

export const CollapsibleHeader: FC<ICollapsibleHeaderProps> = (
    {children, header}: ICollapsibleHeaderProps,
) => (
    <Collapse
        className={cn(s['collapsible-header'])}
        ghost
        defaultActiveKey={['1']}
        expandIcon={() => <AccordionIcon />}
    >
        <Collapse.Panel
            key="1"
            header={header}
            showArrow
        >
            {children}
        </Collapse.Panel>
    </Collapse>
);
